// extracted by mini-css-extract-plugin
export default {"payments":"Payments_payments__yHU6A","hi":"Payments_hi__Xw556","profile":"Payments_profile__sBR3m","scan-qr":"Payments_scan-qr__JAYT9","pay-pi":"Payments_pay-pi__EFZWL"};